export enum Country {
	Czechia = "Czechia",
	Poland = "Poland",
	Germany = "Germany",
	Slovakia = "Slovakia",
	Ukraine = "Ukraine",
	Italy = "Italy",
	Belgium = "Belgium",
	France = "France",
	Israel = "Israel",
	Japan = "Japan",
	Austria = "Austria",
	Slovenia = "Slovenia",
	Spain = "Spain",
	Switzerland = "Switzerland",
	Bulgaria = "Bulgaria",
	China = "China",
	Finland = "Finland",
	Korea = "Korea",
	Lithuania = "Lithuania",
	Hungary = "Hungary",
	Mexico = "Mexico",
	Norway = "Norway",
	Netherlands = "Netherlands",
	Turkey = "Turkey",
	USA = "USA",
}
